import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { Provider } from "react-redux";
import { WagmiProvider } from "wagmi";
import {
  darkTheme,
  getDefaultConfig,
  RainbowKitProvider,
} from "@rainbow-me/rainbowkit";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { bsc , sepolia } from "viem/chains";
import { store } from "./store";

import "@rainbow-me/rainbowkit/styles.css";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const config = getDefaultConfig({
  appName: "My RainbowKit App",
  projectId: "123456f97ff6e43783f84f7908c325c9", // Remember to use your actual Project ID from WalletConnect Cloud
  chains: [bsc], // ✅ Set chains to only BSC Mainnet
  ssr: true,
});

const queryClient = new QueryClient();

root.render(
  <React.StrictMode>
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        <RainbowKitProvider
          theme={darkTheme({
            accentColor: "#facc15", // your yellow
            accentColorForeground: "#2f2e2e", // black text
            borderRadius: "large",
            fontStack: "system",
          })}
        >
          <Provider store={store}>
            <App />
          </Provider>
        </RainbowKitProvider>
      </QueryClientProvider>
    </WagmiProvider>
  </React.StrictMode>
);
